import React from 'react';
import { TopBar } from '../TopBar/TopBar';
import { LeftBar } from '../LeftBar/LeftBar';
import ProcessingTopBar from '../atoms/TopBar/TopBar';
import ProcessingLeftBar from '../atoms/LeftBar/LeftBar';
import { BorrowerData, SelectedIndexData } from '../../../../types';
import { useScrollManagement } from './useScrollManagement';

import './PageLayout.scss';

interface PageLayoutProps {
  children: React.ReactNode;
  isProcessingTeamMode?: boolean;
  isBorrowerMode?: boolean;
  isBrokerMode?: boolean;
  borrowerData?: BorrowerData;
}

export const PageLayout = (props: PageLayoutProps) => {
  const { children, isProcessingTeamMode, isBorrowerMode, isBrokerMode, borrowerData } = props;

  const classNames: string[] = ['page-layout'];
  if (isProcessingTeamMode || isBorrowerMode) {
    classNames.push('processing');
  }
  if (isBrokerMode) {
    classNames.push('broker');
  }
  const className = classNames.join(' ');
  const showAuthLeftBar = isProcessingTeamMode || isBorrowerMode || isBrokerMode;

  return (
    <div className={className}>
      {
        isProcessingTeamMode ?
          <ProcessingTopBar />
          :
          <TopBar />
      }
      <div className='page-main'>
        {
          showAuthLeftBar ?
            <ProcessingLeftBar borrowerData={borrowerData ? { name: borrowerData.name, lastName: borrowerData.lastName } : undefined} />
            :
            <LeftBar />
        }
        <div className='page-content-wrapper'>
          { children }
        </div>
      </div>
    </div>
  );
}

interface PageContentProps {
  children: React.ReactNode;
  isWide?: boolean;
  selectedIndexData: SelectedIndexData;
  setSelectedIndexData: (data: SelectedIndexData) => void;
  currentStep: number;
  maxAllowedStepIndex?: number;
  isStepCompleted?: (flowIndex: number) => boolean;
}

export const PageContent = (props: PageContentProps) => {
  const { children, isWide, selectedIndexData, setSelectedIndexData, currentStep, maxAllowedStepIndex, isStepCompleted } = props;

  const { componentRef } = useScrollManagement({
    selectedIndexData,
    setSelectedIndexData,
    currentStep,
    maxAllowedStepIndex,
    isStepCompleted,
    children,
  });

  const className = isWide ? 'page-content wide' : 'page-content';

  return (
    <div className={className} ref={componentRef}>
      {children}
    </div>
  );
}
